import { html } from "lit";
import {
    dummyPages,
    TeaserPageTemplate,
} from "../../../partial-templates/teaser/page/teaser-page.templates";
import { ViewAllBlockTemplate } from "./view-all.templates";

export const PageSliderTemplate = ({ tab = "pages" }) => html`
    <ux-slider
        breakpoint-s="767"
        breakpoint-m="1200"
        breakpoint-l="1600"
        container-width-s="315px"
        space-between-s="10"
        space-between-m="30"
        space-between-l="40"
        space-between-xl="40"
        visible-slides-s="1"
        visible-slides-m="1"
        visible-slides-l="1"
        visible-slides-xl="1"
        slides-per-column-s="1"
        slides-per-column-m="3"
        slides-per-column-l="3"
        slides-per-column-xl="3"
        faded-sides
        slides-overflow-visible
        container-classes="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1 ux-u-margin-bottom-5 ux-u-margin-m-bottom-25"
    >
        ${dummyPages.map((teaser, index) => {
            if (index > 4) return;
            return html` <ux-slider-slide class="ux-u-margin-top-25">
                ${TeaserPageTemplate(teaser)}
            </ux-slider-slide>`;
        })}
        <ux-slider-slide class="ux-u-margin-top-25">
            ${ViewAllBlockTemplate({
                text: "Alle Ergebnisse anzeigen",
                icon: null,
                tab: tab,
                asButton: true,
                shadow: true,
            })}
        </ux-slider-slide>
        <ux-slider-pagination
            slot="pagination"
            bottom-pagination
        ></ux-slider-pagination>
    </ux-slider>
`;
